import React from 'react';
import { Button, Collapse ,Dialog } from "@blueprintjs/core";
import DataTable from 'components/data-table';
import {RowItemDocumentDetail} from 'modules/reception/datatable/detail';
import {Link} from 'react-router';
import {header} from "constants/table";
import {Reception} from 'api';
import { connect } from 'react-redux';
import moment from 'moment';
import { ShowIf } from 'components/utils';
import {HistoryDialog} from 'modules/dialog'
import classnames from 'classnames';
var Promise = require('es6-promise').Promise;

class ListInfoDocumentDialog extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state={
      pageData: {
        number: 0,
        size: 10
      },
      data: [],
      congDanInfo: {},
      DanhSachDonCongDan: [],
      DanhSachTam: [],
      DanhSachDonCDId: [],
      itemNews: [],
      DanhSachDonCuCDId: []
    }
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.isOpen != this.props.isOpen) {
      if (nextProps.isOpen) {
        this.getCongDanId(nextProps.congDanId);
        this.getDanhSachDonCD(nextProps.congDanId);
      }
    }
  }

  handleClick(index){
    this.state.DanhSachDonCDId.map((item, i) => {
      if (i == index) {
        item.isCollapse = !item.isCollapse;
      } else {
        item.isCollapse = false;
      }
    });
    this.setState({DanhSachDonCDId: this.state.DanhSachDonCDId});
  }


  getCongDanId(cdId) {
    Reception.actions.getcongDan.request({id: cdId}).then(res => {
      if (res.data) {
        this.setState({congDanInfo: res.data});
      }
    });
  }

  chonCongDan(item) {
    this.props.self.hasChange = true;
    this.props.dispatch({
      type: 'CHON_CONG_DAN',
      data: item,
      index: this.props.index
    });
    this.props.dispatch({
      type: 'DISPLAY_FIELD',
      value: true
    });
  }

  layThongTinHoSo(item, congdanInfo) {
    this.chonCongDan(congdanInfo);
    this.props.self.hasChange = true;
    this.props.dispatch({
      type: 'CHON_DON_THU',
      data: item
    });
  }

  async getDanhSachDonCD(cdId) {
    let DanhSachDonCuCDId = [];
    let DanhSachDonCDId = [];
    await Reception.actions.getDanhSachDonCuCDId.request({id: cdId}).then(async (res) => {
      if (res.data._embedded) {
        let data = res.data._embedded.donCus;
        DanhSachDonCuCDId = await Promise.all(data.map(async (item, i) => {
          let newItem = {...item};
          await Reception.actions.getDonCuInfo.request({id: item.donCuId}).then(async (info) => {
            if (info.data) {
              newItem = {
                ...newItem,
                ...info.data
              };
              if (newItem.listTaiLieuBangChung) {
                newItem.listTaiLieuBangChung = newItem.listTaiLieuBangChung.map(subItem => {
                  if (subItem && subItem.taiLieuBangChungId) {
                    delete subItem.taiLieuBangChungId;
                  }
                  return subItem;
                });
              }
            }
          });
          return newItem;
        }));
      }
    });

    await Reception.actions.getDanhSachDonCDId.request({id: cdId}).then(async res => {
      if (res.data._embedded) {
        let data = res.data._embedded.dons;
        DanhSachDonCDId = await Promise.all(data.map(async (item, i) => {
          let newItem = {...item};
          newItem.isCollapse = false;
          if (i === 0) {
            newItem.isCollapse = true;
          }
          await Reception.actions.getDonInfo.request({id: item.donId}).then(info => {
            if (info.data) {
              newItem = {
                ...newItem,
                ...info.data
              };
              if (newItem.listTaiLieuBangChung) {
                newItem.listTaiLieuBangChung = newItem.listTaiLieuBangChung.map(subItem => {
                  if (subItem && subItem.taiLieuBangChungId) {
                    delete subItem.taiLieuBangChungId;
                  }
                  return subItem;
                });
              }
              if (newItem.listTaiLieuVanThuBlockCoQuanDaGiaiQuyet) {
                newItem.listTaiLieuVanThuBlockCoQuanDaGiaiQuyet = newItem.listTaiLieuVanThuBlockCoQuanDaGiaiQuyet.map(subItem => {
                  if (subItem && subItem.taiLieuBangChungId) {
                    delete subItem.taiLieuVanThuId;
                  }
                  return subItem;
                });
              }
            }
          });
          return newItem;
        }));
      }
    });
    this.setState({DanhSachDonCDId,DanhSachDonCuCDId});
  }

  closeDialog() {
    this.props.dispatch({
      type: 'TOGGLE_DIALOG',
      data: {
        name: 'PopupChiTietCongDan',
        status: false
      },
      index: this.props.index
    });
  }

  render() {
    let DanhSachDonCongDan = this.state.DanhSachDonCDId.map((item, i) => (
      <div className="box-forward mb20" key={i}>
        <div className="container-box">
          <div className="block-search-name">
            <div>
              <div className={item.isCollapse ? "items-form header-redirect" : "items-form  header-redirect header-open"}>
                <div className="row-col">
                  <div className="header-col pl20 pr0 flex-column">
                    <div>
                      <p className="txt-bold">Mã đơn</p>
                      {item.maHoSo}
                    </div>
                  </div>
                  <div className="header-col">
                    <p className="txt-bold">Ngày tiếp</p>
                    {item.ngayTiepNhan ? moment(item.ngayTiepNhan).format('DD/MM/YYYY') : ''}
                  </div>
                  <div className="header-col">
                    <p className="txt-bold">Cơ quan đã giải quyết</p>
                    {item.coQuanDaGiaiQuyetDonThu || ''}
                  </div>
                  <div className="header-col">
                    <p className="txt-bold">Cơ quan đang giải quyết</p>
                    {item.coQuanDangQuyetInfo ? item.coQuanDangQuyetInfo.ten : ''}
                  </div>
                  <div className="header-col">
                    <p className="txt-bold">Trạng thái xử lý</p>
                    {item.trangThaiDonGiaiQuyetText ? item.trangThaiDonGiaiQuyetText : ''}
                  </div>
                  <div className="header-col">
                    <HistoryDialog donId={item.donId}/>
                  </div>
                  <div className="header-col">
                    <Button onClick={this.handleClick.bind(this, i)} className={item.isCollapse ? "btn-collap active" : "btn-collap"} />
                  </div>
                </div>
              </div>
            </div>
            <Collapse isOpen={item.isCollapse}>
              <div className="wrap-items">
                <div className="title">
                  <div className="rows">
                    <div className="col-12">
                      <h3>Thông tin đơn</h3>
                    </div>
                  </div>
                </div>
                <div className="items-form">
                  <div className="rows">
                    <div className="col-input">
                      <span className="val-title-bold">
                       Loại đơn thư:
                      </span>
                      <span className="val-content">{item.loaiDonInfo ? item.loaiDonInfo.ten : ''}</span>
                    </div>
                    <ShowIf condition={item.loaiDon ===  "DON_KHIEU_NAI"}>
                      <div className="col-input">
                          <span className="val-title-bold">
                           Loại đối tượng:
                          </span>
                          <span className="val-content">{item.loaiDoiTuongInfo ? item.loaiDoiTuongInfo.ten : ''}</span>
                      </div>
                    </ShowIf>
                    <ShowIf condition={item.loaiDon ===  "DON_TO_CAO"}>
                      <div className="col-input">
                          <span className="val-title-bold">
                           Loại đối tượng bị tố cáo:
                          </span>
                          <span className="val-content">{item.loaiDoiTuongInfo ? item.loaiDoiTuongInfo.ten : ''}</span>
                      </div>
                    </ShowIf>

                    <div className="col-input">
                        <span className="val-title-bold">
                         Lĩnh vực:
                        </span>
                        <span className="val-content">{item.linhVucDonThuDon ? item.linhVucDonThuDon.ten : ''}</span>
                    </div>
                    <ShowIf condition={item && item.linhVucDonThuChiTietDon !== null}>
                      <div className="col-input">
                        <span className="val-title-bold">
                          Lĩnh vực chi tiết:
                        </span>
                        <span className={classnames('val-content', {'arrow-to-dispute' : item.chiTietLinhVucDonThuChiTietDon})}>{item.linhVucDonThuChiTietDon ? item.linhVucDonThuChiTietDon.ten : ''}</span>
                      </div>
                    </ShowIf>
                    {
                      item.chiTietLinhVucDonThuChiTietDon &&
                      <div className="col-input">
                          <span className="val-title-bold">
                           &nbsp;&nbsp;&nbsp;
                          </span>
                          <span className="val-content">{item.chiTietLinhVucDonThuChiTietDon ? item.chiTietLinhVucDonThuChiTietDon.ten : ''}</span>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </Collapse>
            <div className={classnames({
              'wrap-items pt10': item.isCollapse,
              'wrap-items-content': !item.isCollapse
            })}>
              <div className="items-form">
                <div className="rows">
                  <div className="col-12">
                    <span className="val-title-bold">
                     Tóm tắt nội dung đơn thư:
                    </span>
                    <span className="val-content">{item.noiDung}</span>
                  </div>
                </div>
              </div>
            </div>

            <Collapse isOpen={item.isCollapse}>
              <div className="wrap-items">
                <div className="title">
                  <div className="rows">
                      <div className="col-12">
                        <h3>Danh sách tài liệu</h3>
                      </div>
                  </div>
                </div>
                <div className="pl5 pr5">
                  <DataTable
                    header = {header.addReception.boSungTaiLieu}
                    dataList = {item.listTaiLieuBangChung}
                    hidePagination={true}
                    pageData= {this.state.pageData}>
                    <RowItemDocumentDetail/>
                  </DataTable>
                </div>
                <div className="row pl5 pr5 pt5"><div className="line-border"></div></div>
              </div>
              {
                item.thongTinGiaiQuyetDonInfo && item.thongTinGiaiQuyetDonInfo.coQuanDaGiaiQuyetInfo  ?
                  <div className="wrap-items">
                    <div className="title">
                      <div className="rows">
                        <div className="col-12">
                          <h3>Kết quả giải quyết</h3>
                        </div>
                      </div>
                    </div>
                    <div className="items-form">
                      <div className="rows mb10">
                        <div className="col-25">
                          <span className="val-title-bold">
                          Cơ quan giải quyết:
                          </span>
                          <span className="val-content">{item.thongTinGiaiQuyetDonInfo.coQuanDaGiaiQuyetInfo.ten}</span>
                        </div>
                        <div className="col-25">
                          <span className="val-title-bold">
                          Số văn bản:
                          </span>
                          <span className="val-content">{item.thongTinGiaiQuyetDonInfo.soVanBan}</span>
                        </div>
                        <div className="col-25">
                          <span className="val-title-bold">
                           Ngày ban hành:
                          </span>
                          <span className="val-content">{item.thongTinGiaiQuyetDonInfo.ngayBanHanh ? moment(item.thongTinGiaiQuyetDonInfo.ngayBanHanh).format('DD/MM/YYYY') : ''}</span>
                        </div>
                        <div className="col-25">
                          <span className="val-title-bold">
                           Người ban hành:
                          </span>
                          <span className="val-content">{item.thongTinGiaiQuyetDonInfo.nguoiBanHanhInfo ? item.thongTinGiaiQuyetDonInfo.nguoiBanHanhInfo.hoVaTen : ''}</span>
                        </div>
                      </div>
                    </div>
                    <div className="pl5 pr5">
                      <DataTable
                        header={header.addReception.boSungTaiLieu}
                        dataList={item.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ}
                        hidePagination
                        pageData={this.state.pageData}
                      >
                        <RowItemDocumentDetail />
                      </DataTable>
                    </div>
                    <div className="row pl5 pr5 pt5"><div className="line-border"></div></div>
                  </div>
                : ''
              }
            </Collapse>
            {/*end content show when click*/}

            <div className="box-bottom mt15 mb15">
              <Link onClick={this.layThongTinHoSo.bind(this, item, this.state.congDanInfo)} className="btn-action btn-check-file" role="button">
                <span>Lấy thông tin hồ sơ vụ việc</span>
              </Link>
            </div>

          </div>
        </div>
      </div>
    ));
    let DanhSachDonCuCongDan = this.state.DanhSachDonCuCDId.map((item, i) => (
      <div className="box-forward mb20" key={i}>
          <div className="container-box">
            <div className="block-search-name">
              <div className="wrap-items">
                <div className="title">
                  <div className="rows">
                    <div className="col-12">
                      <h3>Thông tin đơn</h3>
                    </div>
                  </div>
                </div>
                <div className="items-form">
                  <div className="rows">
                    <div className="col-input">
                      <span className="val-title-bold">
                        Loại đơn thư:
                      </span>
                      <span className="val-content">{item.loaiDonInfo ? item.loaiDonInfo.ten : ''}</span>
                    </div>
                    <ShowIf condition={item.loaiDon ===  "DON_KHIEU_NAI"}>
                      <div className="col-input">
                        <span className="val-title-bold">
                          Loại đối tượng:
                        </span>
                        <span className="val-content">{item.loaiDoiTuongInfo ? item.loaiDoiTuongInfo.ten : ''}</span>
                      </div>
                    </ShowIf>
                    <ShowIf condition={item.loaiDon ===  "DON_TO_CAO"}>
                      <div className="col-input">
                        <span className="val-title-bold">
                          Loại đối tượng bị tố cáo:
                        </span>
                        <span className="val-content">{item.loaiDoiTuongInfo ? item.loaiDoiTuongInfo.ten : ''}</span>
                      </div>
                    </ShowIf>

                    <div className="col-input">
                      <span className="val-title-bold">
                        Lĩnh vực:
                      </span>
                      <span className="val-content">{item.linhVucDonThuDon ? item.linhVucDonThuDon.ten : ''}</span>
                    </div>
                    <ShowIf condition={item && item.linhVucDonThuChiTietDon !== null}>
                      <div className="col-input">
                        <span className="val-title-bold">
                          Lĩnh vực chi tiết:
                        </span>
                        <span className={classnames('val-content', {'arrow-to-dispute': item.chiTietLinhVucDonThuChiTietDon})}>{item.linhVucDonThuChiTietDon ? item.linhVucDonThuChiTietDon.ten : ''}</span>
                      </div>
                    </ShowIf>
                    {
                      item.chiTietLinhVucDonThuChiTietDon &&
                      <div className="col-input">
                        <span className="val-title-bold">
                          &nbsp;&nbsp;&nbsp;
                        </span>
                        <span className="val-content">{item.chiTietLinhVucDonThuChiTietDon ? item.chiTietLinhVucDonThuChiTietDon.ten : ''}</span>
                      </div>
                    }
                  </div>
                </div>
              </div>
              <div className={classnames({
                'wrap-items pt10': item.isCollapse,
                'wrap-items-content': !item.isCollapse
              })}>
              <div className="items-form">
                <div className="rows">
                  <div className="col-12">
                    <span className="val-title-bold">
                      Tóm tắt nội dung đơn thư:
                    </span>
                    <span className="val-content">{item.noiDung}</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="wrap-items">
              <div className="title">
                <div className="rows">
                  <div className="col-12">
                    <h3>Danh sách tài liệu</h3>
                  </div>
                </div>
              </div>
              <div className="pl5 pr5">
                <DataTable
                  header={header.addReception.boSungTaiLieu}
                  dataList={item.listTaiLieuBangChung}
                  hidePagination={true}
                  pageData= {this.state.pageData}>
                  <RowItemDocumentDetail/>
                </DataTable>
              </div>
              <div className="row pl5 pr5 pt5"><div className="line-border"></div></div>
            </div>
            {
              item.thongTinGiaiQuyetDonInfo && item.thongTinGiaiQuyetDonInfo.coQuanDaGiaiQuyetInfo  &&
              <div className="wrap-items">
                <div className="title">
                  <div className="rows">
                    <div className="col-12">
                      <h3>Kết quả giải quyết</h3>
                    </div>
                  </div>
                </div>
                <div className="items-form">
                  <div className="rows mb10">
                    <div className="col-25">
                      <span className="val-title-bold">
                        Cơ quan đã giải quyết:
                      </span>
                      <span className="val-content">{item.thongTinGiaiQuyetDonInfo.coQuanDaGiaiQuyetInfo.ten}</span>
                    </div>
                    <div className="col-25">
                      <span className="val-title-bold">
                        Số văn bản:
                      </span>
                      <span className="val-content">{item.thongTinGiaiQuyetDonInfo.soVanBan}</span>
                    </div>
                    <div className="col-25">
                      <span className="val-title-bold">
                        Ngày ban hành:
                      </span>
                      <span className="val-content">{item.thongTinGiaiQuyetDonInfo.ngayBanHanh ? moment(item.thongTinGiaiQuyetDonInfo.ngayBanHanh).format('DD/MM/YYYY') : ''}</span>
                    </div>
                    <div className="col-25">
                      <span className="val-title-bold">
                        Người ban hành:
                      </span>
                      <span className="val-content">{item.thongTinGiaiQuyetDonInfo.nguoiBanHanhInfo ? item.thongTinGiaiQuyetDonInfo.nguoiBanHanhInfo.hoVaTen : ''}</span>
                    </div>
                  </div>
                </div>
                <div className="row pl5 pr5 pt5"><div className="line-border"></div></div>
              </div>
            }
            {/*end content show when click*/}
            <div className="box-bottom mt15 mb15">
              <Link onClick={this.layThongTinHoSo.bind(this, item, this.state.congDanInfo)} className="btn-action btn-check-file" role="button">
                <span>Lấy thông tin hồ sơ vụ việc</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    ));
    return (
      <Dialog className="panel-popup" inline={ false } isOpen={ this.props.isOpen } onClose={ this.closeDialog.bind(this) } title="Kết quả tìm kiếm">
        <div className="panel-page" id="page_result_search">
          <div className="main_page">
            <div className="box-content mb20">
                <div className="box-forward">
                  <div className="container-box">
                    <div className="wrap-items style-box-top">
                      <div className="title">
                        <div className="rows">
                            <div className="col-12">
                              <h3>Thông tin người đứng đơn/vụ việc</h3>
                            </div>
                        </div>
                      </div>
                      <div className="items-form">
                          <div className="rows">
                            <div className="col-12 mb15">
                              <label className="val-title-inline-bold mr5">Loại đối tượng: </label>
                              <span className="val-content-inline">Cá nhân</span>
                            </div>
                          </div>
                      </div>
                      <div className="items-form">
                         <div className="rows mb10">
                             <div className="col-input">
                                  <label className="val-title-bold">
                                   Họ và tên:
                                  </label>
                                  <p className="val-content">{this.state.congDanInfo.hoVaTen}</p>
                              </div>
                              <div className="col-input">
                                  <label className="val-title-bold">
                                   Ngày sinh:
                                  </label>
                                  <p className="val-content">{this.state.congDanInfo.ngaySinh ? moment(this.state.congDanInfo.ngaySinh).format('DD/MM/YYYY') : ''}</p>
                              </div>
                              <div className="col-input">
                                  <label className="val-title-bold">
                                   Số điện thoại:
                                  </label>
                                  <p className="val-content">{this.state.congDanInfo.soDienThoai}</p>
                              </div>
                              <div className="col-input">
                                  <label className="val-title-bold">
                                   Giới Tính:
                                  </label>
                                  <p className="val-content">{this.state.congDanInfo.gioiTinh ? 'Nam' : 'Nữ'}</p>
                              </div>
                         </div>
                      </div>
                      <div className="items-form">
                          <div className="rows mb10">
                              <div className="col-input">
                                  <label className="val-title-bold">
                                   Số CMND/ Hộ chiếu:
                                  </label>
                                  <p className="val-content">{this.state.congDanInfo.soCMNDHoChieu}</p>
                              </div>
                              <div className="col-input">
                                  <label className="val-title-bold">
                                   Nơi cấp:
                                  </label>
                                  <p className="val-content">{this.state.congDanInfo.noiCapCMNDInfo ? this.state.congDanInfo.noiCapCMNDInfo.ten : ''}</p>
                              </div>
                              <div className="col-input">
                                  <label className="val-title-bold">
                                   Ngày cấp:
                                  </label>
                                  <p className="val-content">{this.state.congDanInfo.ngayCap ? moment(this.state.congDanInfo.ngayCap).format('DD/MM/YYYY') : ''}</p>
                              </div>
                              <div className="col-input">
                                  <label className="val-title-bold">
                                   Dân tộc:
                                  </label>
                                  <p className="val-content">{this.state.congDanInfo.danTocCongDan ? this.state.congDanInfo.danTocCongDan.ten : ''}</p>
                              </div>
                              <div className="col-input">
                                  <label className="val-title-bold">
                                   Quốc tịch:
                                  </label>
                                  <p className="val-content">{this.state.congDanInfo.quocTichCongDan ? this.state.congDanInfo.quocTichCongDan.ten : ''}</p>
                              </div>
                          </div>
                      </div>
                      <div className="items-form">
                          <div className="rows mb10">
                              <div className="col-input">
                                  <label className="val-title-bold">
                                   Tỉnh:
                                  </label>
                                  <p className="val-content">{this.state.congDanInfo.tinhThanhCongDan ? this.state.congDanInfo.tinhThanhCongDan.ten : ''}</p>
                              </div>
                            <ShowIf condition={this.state.congDanInfo.quanHuyenCongDan != null || this.state.congDanInfo.phuongXaCongDan != null || (this.state.congDanInfo.toThon != '' && this.state.congDanInfo.toThon != null)}>
                              <div className="col-input">
                                  <label className="val-title-bold">
                                   Quận/Huyện:
                                  </label>
                                  <p className="val-content">{this.state.congDanInfo.quanHuyenCongDan ? this.state.congDanInfo.quanHuyenCongDan.ten : ''}</p>
                              </div>
                              <div className="col-input">
                                  <label className="val-title-bold">
                                   Phường/Xã:
                                  </label>
                                  <p className="val-content">{this.state.congDanInfo.phuongXaCongDan ? this.state.congDanInfo.phuongXaCongDan.ten : ''}</p>
                              </div>
                            </ShowIf>
                            <div className="col-w40">
                              <label className="val-title-bold">
                               Địa chỉ:
                              </label>
                              <p className="val-content">{this.state.congDanInfo.diaChi}</p>
                            </div>
                          </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="mb5" style={{marginTop: '15px'}} >
                  <div className="box-bottom">
                    <Link onClick={this.chonCongDan.bind(this, this.state.congDanInfo)} className="btn-action btn-check-file" role="button">
                      <span>Lấy thông tin người đứng đơn</span>
                    </Link>
                  </div>
                </div>
                {/*box-forward*/}
            </div>
            <div className="row pl15 pr15 pt5"><div className="line-border"></div></div>
            <div className="box-content box-items none-boder-bt">
              <div className="heading-box-show">
                <div className="rows">
                    <div className="col-12">
                      <h3>{this.state.DanhSachDonCDId.length + this.state.DanhSachDonCuCDId.length} hồ sơ vụ việc</h3>
                    </div>
                </div>
              </div>
              {DanhSachDonCongDan}
              {DanhSachDonCuCongDan}
            </div>
            {/*box-forward*/}
            <div className="box-bottom">
              <Link className="btn-action btn-close" onClick={this.closeDialog.bind(this)}>
                <span>Đóng</span>
              </Link>
            </div>
          </div>
        </div>
      </Dialog>
    );
  }
}

function bindStateToProps(state) {
  return {
    isOpen: state.formDataTiepCongDan.PopupChiTietCongDan,
    congDanId: state.formDataTiepCongDan.viewDetailCongDanId,
    loaiDonThuData: state.duLieuHeThong.loaiDonThu,
    loaiDoiTuongData: state.duLieuHeThong.loaiDoiTuong,
    index: state.formDataTiepCongDan.index
  };
}

export default connect(bindStateToProps)(ListInfoDocumentDialog);



// WEBPACK FOOTER //
// ./src/components/modules/reception/add-reception/ListInfoDocumentDialog.jsx